import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // Close the menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  // Lock body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen(v => !v);
  const closeMenu = () => setIsMenuOpen(false);

  const navClass = ({ isActive }) => (isActive ? 'active' : undefined);

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMenu}>
            <h2>Pure Drop</h2>
            <span>Technicals</span>
          </Link>

          {/* Desktop nav */}
          <nav className="nav nav-desktop" aria-label="Main navigation">
            <ul className="nav-list">
              <li><NavLink to="/" className={navClass} end>Home</NavLink></li>
              <li><NavLink to="/about" className={navClass}>About</NavLink></li>
              <li><NavLink to="/services" className={navClass}>Services</NavLink></li>
              <li><NavLink to="/how-it-works" className={navClass}>How It Works</NavLink></li>
              <li><NavLink to="/why-choose" className={navClass}>Why Choose Us</NavLink></li>
              <li><NavLink to="/products" className={navClass}>Products</NavLink></li>
              <li><NavLink to="/contact" className={navClass}>Contact</NavLink></li>
            </ul>
            <div className="header-cta">
              <NavLink to="/request" className="btn btn-primary">Get Quote</NavLink>
            </div>
          </nav>

          {/* Burger */}
          <button
            type="button"
            className="mobile-menu-toggle"
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen ? 'true' : 'false'}
            aria-controls="mobile-drawer"
            onClick={toggleMenu}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      {/* Overlay (behind drawer) */}
      {isMenuOpen && (
        <button
          type="button"
          className="nav-overlay"
          aria-label="Close navigation overlay"
          onClick={closeMenu}
        />
      )}

      {/* Mobile Drawer (always above everything) */}
      <aside
        id="mobile-drawer"
        className={`mobile-drawer ${isMenuOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="drawer-header">
          <span className="drawer-title">Menu</span>
          <button type="button" className="drawer-close" onClick={closeMenu} aria-label="Close menu">✕</button>
        </div>

        <nav className="drawer-nav" aria-label="Mobile navigation">
          <NavLink to="/" className={navClass} end onClick={closeMenu}>Home</NavLink>
          <NavLink to="/about" className={navClass} onClick={closeMenu}>About</NavLink>
          <NavLink to="/services" className={navClass} onClick={closeMenu}>Services</NavLink>
          <NavLink to="/how-it-works" className={navClass} onClick={closeMenu}>How It Works</NavLink>
          <NavLink to="/why-choose" className={navClass} onClick={closeMenu}>Why Choose Us</NavLink>
          <NavLink to="/products" className={navClass} onClick={closeMenu}>Products</NavLink>
          <NavLink to="/contact" className={navClass} onClick={closeMenu}>Contact</NavLink>
        </nav>

        <div className="drawer-cta">
          <NavLink to="/request" className="btn btn-primary" onClick={closeMenu}>Get Quote</NavLink>
        </div>
      </aside>
    </header>
  );
};

export default Header;